export const MAIL_REGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
export const PHONE_REGEX = /^\+[0-9]{9,18}$/;
export const PHONE_OR_MAIL_REGEX = /(^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,})|(^(\+|0)[0-9]{9,18})$/i;
export const VERIFICATION_CODE_REGEX = /^[\d]{6}$/;
